import React from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import "./AboutUs.css";

const AboutUs = () => {
  const navigate = useNavigate();

  const values = [
    {
      icon: "💡",
      title: "Innovation First",
      description:
        "We push the boundaries of what's possible with AI, constantly exploring new frontiers and breakthrough technologies.",
    },
    {
      icon: "👥",
      title: "Community Driven",
      description:
        "Our platform thrives on the collective intelligence of developers, creators, and innovators worldwide.",
    },
    {
      icon: "🛡️",
      title: "Trust & Security",
      description:
        "We maintain the highest standards of security and ethical AI practices to protect our users and their data.",
    },
    {
      icon: "❤️",
      title: "Human-Centric",
      description:
        "Every AI agent we host is designed to augment human capabilities, not replace human creativity and judgment.",
    },
  ];

  const stats = [
    { number: "50K+",  label: "Active Users",  icon: "👤" },
    { number: "5K+",   label: "AI Agents",     icon: "⚡" },
    { number: "100+",  label: "Countries",     icon: "🌍" },
    { number: "99.9%", label: "Uptime",        icon: "🏆" },
  ];

  return (
    <div className="about-page">
      <Navbar />

      {/* ── Hero ── */}
      <div className="about-hero">
        <div className="about-eyebrow">
          <span className="about-eyebrow-dot" />
          Who We Are
        </div>
        <h1>
          About <span>Aisle Agent</span>
        </h1>
        <p>
          We're building the world's largest marketplace for AI agents,
          connecting creators with users who need intelligent automation
          solutions for their everyday challenges.
        </p>
      </div>

      {/* ── Main content ── */}
      <main className="about-main">

        {/* Mission card */}
        <div className="about-card">
          <div className="about-card-heading">
            <span className="about-card-heading-bar" />
            <span className="about-card-icon">🎯</span>
            <h2>Our Mission</h2>
          </div>
          <div className="about-mission-text">
            <p>
              To democratize access to artificial intelligence by creating a
              thriving ecosystem where anyone can discover, deploy, and benefit
              from specialized AI agents tailored to their unique needs.
            </p>
            <p>
              We believe AI should be accessible, ethical, and empowering. Our
              platform bridges the gap between cutting-edge AI research and
              practical, everyday applications that make life easier and work
              more productive.
            </p>
          </div>
        </div>

        {/* Stats panel */}
        <div className="about-stats-grid">
          {stats.map((stat, i) => (
            <div className="about-stat" key={i}>
              <div className="about-stat-icon">{stat.icon}</div>
              <span className="about-stat-number">{stat.number}</span>
              <span className="about-stat-label">{stat.label}</span>
            </div>
          ))}
        </div>

        {/* Values card */}
        <div className="about-card">
          <div className="about-card-heading">
            <span className="about-card-heading-bar" />
            <span className="about-card-icon">✨</span>
            <h2>Our Values</h2>
          </div>
          <div className="about-values-grid">
            {values.map((value, i) => (
              <div className="about-value-item" key={i}>
                <div className="about-value-icon">{value.icon}</div>
                <h3 className="about-value-title">{value.title}</h3>
                <p className="about-value-desc">{value.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* CTA card */}
        <div className="about-cta-card">
          <h2>Join Our Mission</h2>
          <p>
            Discover AI agents built to transform the way you work, create,
            and solve problems — every day.
          </p>
          <div className="about-cta-buttons">
            <button
              className="about-btn-primary"
              onClick={() => navigate("/prelogin")}
            >
              Explore Agents →
            </button>
            <button
              className="about-btn-secondary"
              onClick={() => navigate("/contact")}
            >
              Contact Us
            </button>
          </div>
        </div>

      </main>

      <Footer />
    </div>
  );
};

export default AboutUs;